import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function TimelinePage() {
  const events = [
    {
      canti: 'Canto I',
      title: 'La Peste e l\'Ira di Achille',
      description: 'Apollo scatena una peste nel campo greco perché Agamennone ha disonorato il suo sacerdote Crise. Achille convoca un\'assemblea e il conflitto con Agamennone esplode quando il re sottrae ad Achille la schiava Briseide. Achille si ritira dalla battaglia e sua madre Teti supplica Zeus di onorare il figlio.',
      image: 'https://public.readdy.ai/ai/img_res/7afd82ffdba4a4c4e278fb7e8830f380.jpg',
      color: 'red'
    },
    {
      canti: 'Canti II-III',
      title: 'Il Catalogo delle Navi e il Duello Mancato',
      description: 'Agamennone mette alla prova l\'esercito greco. Segue il famoso "Catalogo delle Navi", elenco di tutti i contingenti greci. Paride sfida Menelao a duello per decidere le sorti della guerra, ma Afrodite salva Paride portandolo via dal campo di battaglia.',
      image: 'https://readdy.ai/api/search-image?query=ancient%20greek%20ships%20fleet%20on%20beach%20warriors%20assembling%20for%20battle%20trojan%20war%20naval%20scene%20classical%20art%20epic%20scale&width=600&height=800&seq=timeline-canto2-002&orientation=portrait',
      color: 'blue'
    },
    {
      canti: 'Canti IV-VII',
      title: 'La Battaglia Riprende',
      description: 'Gli dei rompono la tregua e la battaglia riprende. Diomede compie grandi imprese, ferendo persino Afrodite e Ares. Ettore torna a Troia per chiedere preghiere ad Atena e incontra la moglie Andromaca in una scena commovente. Ettore e Aiace si sfidano in duello che termina in parità.',
      image: 'https://readdy.ai/api/search-image?query=hector%20and%20andromache%20farewell%20scene%20troy%20city%20walls%20emotional%20goodbye%20wife%20and%20child%20ancient%20greece%20classical%20painting%20touching%20moment&width=600&height=800&seq=timeline-canto4-003&orientation=portrait',
      color: 'amber'
    },
    {
      canti: 'Canti VIII-X',
      title: 'I Troiani Avanzano',
      description: 'Zeus proibisce agli altri dei di intervenire e i Troiani, guidati da Ettore, respingono i Greci fino alle navi. Agamennone invia un\'ambasceria ad Achille offrendo doni e scuse, ma l\'eroe rifiuta. Di notte, Odisseo e Diomede compiono una missione di spionaggio.',
      image: 'https://readdy.ai/api/search-image?query=trojan%20warriors%20attacking%20greek%20ships%20on%20beach%20night%20scene%20torches%20flames%20battle%20epic%20warfare%20ancient%20combat&width=600&height=800&seq=timeline-canto8-004&orientation=portrait',
      color: 'orange'
    },
    {
      canti: 'Canti XI-XV',
      title: 'La Crisi Greca',
      description: 'I Troiani continuano ad avanzare. Molti eroi greci vengono feriti: Agamennone, Diomede, Odisseo. I Troiani sfondano il muro greco e attaccano le navi. Patroclo, vedendo la situazione disperata, supplica Achille di lasciarlo combattere.',
      image: 'https://readdy.ai/api/search-image?query=greek%20warriors%20wounded%20in%20battle%20desperate%20defense%20ships%20burning%20trojan%20assault%20dramatic%20action%20ancient%20warfare&width=600&height=800&seq=timeline-canto11-005&orientation=portrait',
      color: 'red'
    },
    {
      canti: 'Canto XVI',
      title: 'La Morte di Patroclo',
      description: 'Achille presta la sua armatura a Patroclo, che guida i Mirmidoni in battaglia. Patroclo respinge i Troiani e uccide molti guerrieri, ma Apollo lo stordisce, Euforbo lo ferisce ed Ettore gli dà il colpo mortale. È il punto di svolta del poema.',
      image: 'https://readdy.ai/api/search-image?query=patroclus%20death%20scene%20fallen%20greek%20warrior%20achilles%20armor%20on%20ground%20hector%20standing%20dramatic%20moment%20trojan%20war%20tragedy%20classical%20art&width=600&height=800&seq=timeline-canto16-006&orientation=portrait',
      color: 'gray'
    },
    {
      canti: 'Canti XVII-XVIII',
      title: 'Il Lutto di Achille',
      description: 'Si combatte ferocemente per il corpo di Patroclo. Menelao e Aiace riescono a portarlo via. Achille apprende della morte dell\'amico e il suo dolore è immenso. Teti chiede a Efesto di forgiare nuove armi divine per il figlio.',
      image: 'https://readdy.ai/api/search-image?query=achilles%20mourning%20patroclus%20grief%20despair%20ancient%20greek%20warrior%20crying%20emotional%20scene%20classical%20sculpture%20dramatic%20lighting&width=600&height=800&seq=timeline-canto17-007&orientation=portrait',
      color: 'indigo'
    },
    {
      canti: 'Canti XIX-XX',
      title: 'Il Ritorno di Achille',
      description: 'Achille si riconcilia con Agamennone e torna in battaglia assetato di vendetta. Gli dei scendono sul campo di battaglia, dividendosi tra le due fazioni. Achille semina morte tra i Troiani, cercando disperatamente Ettore.',
      image: 'https://readdy.ai/api/search-image?query=achilles%20in%20divine%20armor%20returning%20to%20battle%20fury%20rage%20golden%20weapons%20god-forged%20shield%20epic%20warrior%20classical%20art&width=600&height=800&seq=timeline-canto19-008&orientation=portrait',
      color: 'yellow'
    },
    {
      canti: 'Canti XXI-XXII',
      title: 'Il Duello Finale',
      description: 'Achille combatte contro il fiume Scamandro. Ettore, nonostante i presagi funesti, decide di affrontare Achille. Dopo un inseguimento intorno alle mura di Troia, ingannato da Atena, Ettore affronta Achille e viene ucciso. Achille trascina il corpo dietro il suo carro.',
      image: 'https://readdy.ai/api/search-image?query=achilles%20versus%20hector%20final%20duel%20outside%20troy%20walls%20epic%20confrontation%20two%20warriors%20fighting%20classical%20greek%20art%20dramatic%20moment&width=600&height=800&seq=timeline-canto21-009&orientation=portrait',
      color: 'red'
    },
    {
      canti: 'Canto XXIII',
      title: 'I Giochi Funebri',
      description: 'Si celebrano i funerali di Patroclo con un\'elaborata cerimonia. Achille organizza giochi atletici in onore dell\'amico: gara di carri, pugilato, lotta, corsa, duello, lancio del peso, tiro con l\'arco. È un momento di tregua e umanità.',
      image: 'https://readdy.ai/api/search-image?query=ancient%20greek%20funeral%20games%20athletic%20competitions%20chariot%20race%20warriors%20competing%20classical%20antiquity%20ceremonial%20event&width=600&height=800&seq=timeline-canto23-010&orientation=portrait',
      color: 'green'
    },
    {
      canti: 'Canto XXIV',
      title: 'Priamo e Achille',
      description: 'Guidato da Ermes, il vecchio re Priamo si reca nella tenda di Achille per supplicarlo di restituire il corpo di Ettore. Achille, commosso, accetta e concede una tregua per i funerali. Il poema si chiude con i funerali di Ettore, domatore di cavalli.',
      image: 'https://readdy.ai/api/search-image?query=priam%20kneeling%20before%20achilles%20elderly%20king%20supplicating%20warrior%20tent%20scene%20emotional%20reconciliation%20classical%20painting%20humanistic%20moment&width=600&height=800&seq=timeline-canto24-011&orientation=portrait',
      color: 'violet'
    }
  ];

  const colorClasses = {
    red: 'bg-red-500',
    blue: 'bg-blue-500',
    amber: 'bg-amber-500',
    orange: 'bg-orange-500',
    gray: 'bg-gray-500',
    indigo: 'bg-indigo-500',
    yellow: 'bg-yellow-500',
    green: 'bg-green-500',
    violet: 'bg-violet-500'
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-green-50 to-emerald-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 bg-green-100 px-4 py-2 rounded-full mb-6">
            <i className="ri-time-line text-green-600"></i>
            <span className="text-green-800 text-sm font-semibold whitespace-nowrap">Sequenza Narrativa</span>
          </div>
          <h1 className="font-serif text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Timeline degli Eventi
          </h1>
          <p className="text-xl text-gray-700 leading-relaxed">
            Segui passo dopo passo gli eventi narrati nei 24 canti dell'Iliade, dalla peste divina ai funerali di Ettore.
          </p>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6">
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-8 top-0 bottom-0 w-1 bg-gray-200 hidden md:block"></div>
            
            <div className="space-y-12">
              {events.map((event, index) => (
                <div key={index} className="relative">
                  {/* Timeline Dot */}
                  <div className={`absolute left-0 w-16 h-16 ${colorClasses[event.color as keyof typeof colorClasses]} rounded-full flex items-center justify-center text-white font-bold text-lg hidden md:flex`}>
                    {index + 1}
                  </div>
                  
                  {/* Content */}
                  <div className="md:ml-24 bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow">
                    <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
                      <div className="lg:col-span-2 h-64 lg:h-auto">
                        <img 
                          src={event.image}
                          alt={event.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="lg:col-span-3 p-8">
                        <span className={`inline-block ${colorClasses[event.color as keyof typeof colorClasses]} text-white px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap`}>
                          {event.canti}
                        </span>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">{event.title}</h3>
                        <p className="text-gray-700 leading-relaxed">{event.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Summary */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-white mb-8 text-center">Struttura Narrativa</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-800 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Inizio: L'Ira</h3>
              <p className="text-gray-300 leading-relaxed">
                Canti I-IX: Il conflitto tra Achille e Agamennone, il ritiro dell'eroe e le conseguenze per i Greci.
              </p>
            </div>
            <div className="bg-gray-800 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-sword-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Climax: La Vendetta</h3>
              <p className="text-gray-300 leading-relaxed">
                Canti X-XXII: La morte di Patroclo, il ritorno di Achille e il duello finale con Ettore.
              </p>
            </div>
            <div className="bg-gray-800 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Fine: La Pietà</h3>
              <p className="text-gray-300 leading-relaxed">
                Canti XXIII-XXIV: I giochi funebri, l'incontro tra Priamo e Achille, i funerali di Ettore.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Moments */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Momenti Chiave da Ricordare</h2>
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-anger-line text-red-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">La Collera di Achille (Canto I)</h3>
                  <p className="text-gray-700">Il tema centrale del poema: l'ira dell'eroe offeso che si ritira dalla battaglia.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-2-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Ettore e Andromaca (Canto VI)</h3>
                  <p className="text-gray-700">L'addio commovente tra l'eroe troiano e la sua famiglia, momento di grande umanità.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-skull-line text-gray-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">La Morte di Patroclo (Canto XVI)</h3>
                  <p className="text-gray-700">Il punto di svolta: la morte dell'amico trasforma Achille da eroe offeso a vendicatore implacabile.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-flash-line text-yellow-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Le Armi Divine (Canto XVIII)</h3>
                  <p className="text-gray-700">Efesto forgia per Achille armi magnifiche, tra cui lo scudo decorato con scene del cosmo.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-sword-line text-red-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Il Duello Achille-Ettore (Canto XXII)</h3>
                  <p className="text-gray-700">Lo scontro finale tra i due più grandi guerrieri, culmine dell'azione del poema.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-hand-heart-line text-violet-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Priamo e Achille (Canto XXIV)</h3>
                  <p className="text-gray-700">Il momento più umano del poema: il vecchio re supplica l'uccisore di suo figlio, che si commuove.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Study Tips */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-3xl p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-lightbulb-line text-indigo-600"></i>
              Consigli per lo Studio
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Per memorizzare la sequenza:</strong> Dividi i 24 canti in tre grandi blocchi: l'ira (I-IX), la vendetta (X-XXII), la pietà (XXIII-XXIV).
              </p>
              <p>
                <strong>Concentrati sui momenti chiave:</strong> Non è necessario ricordare ogni dettaglio. Focalizzati sui sei momenti fondamentali elencati sopra.
              </p>
              <p>
                <strong>Collega eventi e personaggi:</strong> Ogni evento importante coinvolge personaggi specifici. Associa i momenti chiave ai protagonisti.
              </p>
              <p>
                <strong>Usa la struttura narrativa:</strong> L'Iliade ha una struttura circolare: inizia con l'ira e finisce con la riconciliazione. Questo schema aiuta a ricordare.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row gap-4 justify-between">
            <Link to="/personaggi" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              <span className="whitespace-nowrap">Personaggi Principali</span>
            </Link>
            <Link to="/risorse" className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition-colors font-semibold cursor-pointer">
              <span className="whitespace-nowrap">Risorse Didattiche</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
